var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "question-section" },
    [
      _c("div", { staticClass: "question-section__row" }, [
        _c("h2", { staticClass: "question-section__heading" }, [
          _vm._v(_vm._s(_vm.heading)),
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "question-section__divider" }),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }